import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { TableTemplateColumnConfig } from '@components/ui/table-template/models/table-template-column-config';
import { DataViewModel } from '@components/ui/table-template/models/data-view-model';
import { TableCell } from '@components/ui/table-template/cells/table-cell';
import { DataViewModelValue } from '@components/ui/table-template/models/data-view-model-value';
import { FormattedNumber } from '@components/ui/table-template/classes/formatted-number';

@Component({
    selector: 'app-table-cell-text',
    templateUrl: './table-cell-text.component.html',
    styleUrls: ['./table-cell-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableCellTextComponent implements TableCell {
  public readonly value = signal<string>('');

  initialize(column: TableTemplateColumnConfig, row: DataViewModel, cell: DataViewModelValue): void {
    if (cell instanceof FormattedNumber) {
      this.value.set(cell.displayValue);
    } else {
      this.value.set(cell as string);
    }
  }
}
